module.exports = __webpack_public_path__ + "static/main-picture-e443bb1faea14963b946c536d4de418d.png";